import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AddCategoryModel } from 'src/app/models/category/addCategory.model';
import { CategoryService } from 'src/app/services/category.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';

@Component({
  selector: 'app-category-add',
  templateUrl: './category-add.component.html',
  styleUrls: ['./category-add.component.css']
})
export class CategoryAddComponent implements OnInit {
  addCategory: AddCategoryModel;
  Loader: boolean = false;

  constructor(private localstorage: LocalstorageService, private _categoryService: CategoryService, private alertify: AlertifyService, private router: Router) {
    this.localstorage.setMenu("4");
    this.addCategory = new AddCategoryModel();
  }

  ngOnInit() {
  }

  addCategoryData() {
    if (this.addCategory.CategoryName == undefined || this.addCategory.CategoryName == null || this.addCategory.CategoryName == "") {
      this.alertify.error("Category Name is required");
      return;
    }
    this.Loader = true;
    this._categoryService.addCategory(this.addCategory).subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.addCategory = responseBody.responseData;
        this.alertify.success(responseBody.responseMessage);
        this.Loader = false;
        this.router.navigate(['categoryListing']);
      } else {
        this.alertify.error(responseBody.responseMessage);
        this.Loader = false;
      }
    })

  }
}
